import React from 'react';
import { getIcons } from '_helpers';

export { FleetBusStatusCard };
 
function FleetBusStatusCard({ data }) {

    if (!data) {
        return null; 
    } 

    const nbDepot = data.filter(item => item.STATE === "DEPOT").length ?? 0,
        nbExploit = (data.filter(item => item.STATE === "EN EXPLOITATION").length + data.filter(item => item.STATE === "EN ATTENTE").length) ?? 0,
        nbCharge = data.filter(item => item.STATE === "EN CHARGE").length ?? 0,
        nbInconnu = data.filter(item => item.STATE === "INCONNU").length ?? 0,
        nbOffline = (data.length - (nbDepot + nbExploit + nbCharge + nbInconnu)) ?? 0;

    return (
        <div className={`flex side-panel-card dark-blue`}>
            <div className="flex flex-col gap-4 px-4 pb-2 w-full">
                {/* Première ligne : titre */}
                <div className="flex flex-col gap-4 w-full text-center">
                    <div className="flex-1 text-2xl uppercase">État des véhicules</div>                    
                </div>
                {/* Deuxième ligne divisée en 4 sur la longueur */}   
                {data.length === 0 ? (
                    <div  className="flex text-center items-center justify-center">
                        Aucun bus enregistré
                    </div>
                ) : (
                <div className='flex gap-4 w-full'>                                          
                    <div className="flex-1 ">
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('warehouseOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Au dépôt</div>
                            <div className="value">{nbDepot}</div>
                        </div>
                    </div>
                    <div className="flex-1 ">
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('playCircleOutlineOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">En exploitation</div>
                            <div className="value">{nbExploit}</div>
                        </div>
                    </div>
                    <div className="flex-1 ">                             
                        <div className="icon-group details-section">
                            <div className="icon pl-2"><img className='h-full' src={getIcons('chargingStationOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">En charge</div>
                            <div className="value">{nbCharge}</div>
                        </div>
                    </div>
                    <div className="flex-1 ">                             
                        <div className="icon-group details-section">
                            <div className="icon pl-2"><img className='h-full' src={getIcons('noTransferOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Offline</div>
                            <div className="value">{nbOffline}</div>
                        </div>
                    </div>  
                    <div className="flex-1 ">                             
                        <div className="icon-group details-section">
                            <div className="icon pl-2"><img className='h-full' src={getIcons('directionsBusFilledOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Inconnu</div>
                            <div className="value">{nbInconnu}</div>
                        </div>
                    </div>                
                </div>)}
            </div>
        </div>
    );
};
